import styled from "styled-components";

export const Container = styled.div`
    width: 100%;
    max-width: 1440px;
    margin: auto;
    display: flex;
    flex: 1;
    flex-direction: column;
    overflow: auto;
`;
